import { PageTitle } from '@/shared/ui/text/page-title';
import { AuthenticatedShell } from '@/widgets/layout/authenticated-shell';
import { UserDropdown } from '@/widgets/user/user-dropdown';

export function PracticeMembersPage() {
    return (
        <AuthenticatedShell dropdown={<UserDropdown />}>
            <main className="flex min-w-0 flex-1 flex-col overflow-y-auto px-10 pt-8">
                <PageTitle>Practice Members</PageTitle>
            </main>
        </AuthenticatedShell>
    );
}
